module.exports = __webpack_public_path__ + "img/waterfowl_7.6110b495.jpg";